import { create } from "zustand"

import { type IVariantSummary } from "~/hooks/useVariantTableData"

type FlagsActionDialogStore = {
  open: boolean
  variants: IVariantSummary[]
  openDialog: (variants: IVariantSummary[]) => void
  closeDialog: () => void
}

export const useFlagsActionDialogStore = create<FlagsActionDialogStore>((set) => ({
  open: false,
  variants: [],
  openDialog: (variants) => set({ open: true, variants }),
  closeDialog: () => set({ open: false }),
}))
